export default {
  filters: {
    next: 'Next',
    back: 'Back',
    smartMatchingTitle: 'Smart Matching',
    smartMatchingDescription: 'A tool to find the most impactful and environmental friendly solutions for almost every kind of waste in real-time to enable ' +
      'wide collaboration between all parties of the circular economy - business, consumers, and makers.',
    material: 'Material',
    materials: 'Waste materials:',
    materialsDescription: 'Which type of waste do you want to transform ?',
    categories: 'Type of product:',
    categoriesDescription: 'Which type of product to you want to obtain ?',
    location: 'Location:',
    locationLabel: 'Start typing to find location',
    radius: 'Radius (km)',
    advancedFiltersButton: 'Advanced filters',
    showTourGuide: 'Show tour guide',
  },
  filtersHeader: {
    chosenFilters: 'Chosen filters:',
    location: 'location: {location}',
    price: 'price: {price}',
    radius: 'radius: {radius}',
    clearFilters: 'Clear all',
  },
  products: {
    noProducts: 'We did not find your products. Please {contact}',
    contactUs: 'Contact Us',
  },
  guideModal: {
    firstStep: {
      areYouReady: 'Are you ready?',
      contactUs: 'Let us connect you with the best designers and their products',
      useSmartMatching: 'Use our smart matching system and find best products in simple steps',
      start: 'Start',
      hideForever: 'Do not show this guide again',
    },
    secondStep: {
      chooseTheWasteMaterial: 'Step 1: Choose the waste material',
      description: 'Please specify what kind of waste streams you want to utilize for the upcycling production.',
      next: 'Next',
    },
    thirdStep: {
      chooseTypeOfProduct: 'Step 2: Choose type of product',
      description: 'Please select the product category you are interested in.',
      showResults: 'Show results',
    },
  },
};